import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

interface SchoolNotListedProps {
}

interface SchoolNotListedState {
    tooltipIsOpen: boolean;
}

export class SchoolNotListedComponent extends React.Component<SchoolNotListedProps, SchoolNotListedState> {

    constructor(props: SchoolNotListedProps) {
        super(props);
        this.state = {
            tooltipIsOpen: false,
        };
        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
    }

    showTooltip() {
        this.setState({
            tooltipIsOpen: true,
        });
    }

    hideTooltip() {
        this.setState({
            tooltipIsOpen: false,
        });
    }

    public render() {

        const handleBlur = () => setTimeout(this.hideTooltip, 0);
        return (
            <div
                tabIndex={0}
                className="sid-school-not-listed"
                aria-describedby="school-not-listed"
                onMouseEnter={this.showTooltip}
                onMouseLeave={this.hideTooltip}
                onFocus={this.showTooltip}
                onBlur={handleBlur}
            >
                <span className="sid-link">
                    <FormattedHTMLMessage id="schoolNotListed"
                        defaultMessage="School not listed?" />
                </span>
                {
                    this.state.tooltipIsOpen ?
                        <div className="sid-school-not-listed__container">
                            <div className="sid-school-not-listed__caret" />
                            <div className="sid-school-not-listed__tooltip" role="tooltip" id="school-not-listed">
                                <FormattedHTMLMessage
                                    id="step.personalInfo.schoolNotFound"
                                    defaultMessage="Email us at <a href='sid-link' href='mailto:education@intuit.com'>education@intuit.com</a> to determine if your school is eligible."
                                />
                            </div>
                        </div>
                        :
                        null
                }
            </div>
        );
    }
}
